import { Box, SxProps } from '@mui/material';
import { Button } from '@portals/core/src/components/Button/Button';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import { getFixedT } from 'i18next';
import React from 'react';

import { CockpitRedirectDialog } from '../../../components';
import { useCockpitRedirectDialog } from '../../../hooks';
import { theme } from '../../../themes/main';
import { SxStyles } from '../../../types';

const t = getFixedT(null, 'core-immobilien', 'watchlist.cockpit');

const styles: SxStyles = {
  cockpitBox: {
    bgcolor: theme.palette.surface.advice,
    borderRadius: theme.borderRadius.md,
    p: 5,
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 5, lg: 8 },
    whiteSpace: 'pre-line',
    height: '100%',
  },
  cockpitButton: {
    mt: { xs: 4, sm: 'auto' },
  },
};

type CockpitBoxProps = {
  sx?: SxProps;
  title?: string;
  content?: string;
};

export const CockpitBox: React.FC<CockpitBoxProps> = ({ sx, title, content }) => {
  const { onSave, onRedirect, onClose, isOpen, isDisabled } = useCockpitRedirectDialog();

  return (
    <>
      {isOpen && <CockpitRedirectDialog onClose={onClose} onRedirect={onRedirect} />}
      <Box sx={{ ...styles.cockpitBox, ...sx } as SxStyles}>
        {title && <Typography variant="h4">{title}</Typography>}
        {content && <Typography variant="body2">{content}</Typography>}
        <Button fullWidth sx={styles.cockpitButton} onClick={onSave} disabled={isDisabled}>
          {t('saveButton')}
        </Button>
      </Box>
    </>
  );
};

CockpitBox.displayName = 'CockpitBox';
